<div class="login-container">
    <div class="login-box">
        <h1>Welcome to</h1> 

        <div  class="brand-wrapper">
            <img src="/images/OCELUS-Logo-02.svg" alt="logo" width="350px">
            <!-- <h1>Ocelus</h1> -->
        </div>

        <!-- <h3><strong>Align | Collaborate | Deliver</strong></h3> -->

        <p style="padding-left: 30px; padding-right: 30px;">
            Smart tool for managing projects and events, helping teams align, collaborate, and deliver with ease.
        </p>

        <div class="google-signin">
            <div id="google-signin-button"></div>
        </div>

        <p class="copy-rights">© {{currentYear}} BuyerForesight</p>
    </div>
</div>